import {initializeLoadMoreButtons} from "./initialize.js";
initializeLoadMoreButtons();
